import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setColor } from "../../store/reducers/ColorReducer";
import NewsEvents from "../../components/home/NewsEvents";
import OurServices from "../../components/home/OurServices";
import { clientUrls } from "../../constants/ClientUrls";
import CommonYoutube from "../../components/CommonYoutube";
import "../../css/pagescss/Services.css";
import Footer from "../../components/Footer";
import { useNavigate } from "react-router-dom";
import {
  FormatTextFromGeneralConstants,
  getLanguage,
  navigateTo,
} from "../../constants/GeneralConstants";
import { Link } from "react-router-dom";
import Loader from "../Loader";
import { getServicesPageData } from "../../services/ApiService";
import PIL from "../PIL";
import SwiperSlideCommon from "../SwiperSlideCommon";
import ButtonSlant from "../ButtonSlant";
import { SlantImg } from "../CommonComponents";
import CommonTopBanner from "./CommonTopBanner";
import FormatText from "../FormatText";
import AAACoDev from "./AAACoDev";

const SoftwareTesting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { lang } = useParams();

  const [loader, setLoader] = useState(true);
  const [softwareTestingPageData, setSoftwareTestingPageData] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  useEffect(() => {
    callSoftwareTestingApi(getLanguage());
  }, [lang]);
  const callSoftwareTestingApi = async (language) => {
    setLoader(true);
    try {
      let data = await getServicesPageData(language, {
        type: "software-testing",
      });
      document.title =
        data?.qaSoftObject?.testPageData?.softwareTestingSEOTitle;
      setSoftwareTestingPageData(data);
      dispatch(
        setColor({
          primary: data?.qaSoftObject?.serviceColors[0]?.colorCode,
          secondary: data?.qaSoftObject?.serviceColors[0]?.secondaroyColor,
          tertiary: data?.qaSoftObject?.serviceColors[0]?.tertiaryColor,
        })
      );
      setLoader(false);
    } catch (err) {
      console.log(err);
    }
  };
  console.log();
  const {
    testPageData,
    services,
    serviceColors,
    benifits,
    subServices,
    industry,
    labs,
  } = softwareTestingPageData?.qaSoftObject || {};

  if (loader) {
    return <Loader />;
  }
  return (
    <>
      <section>
        <section
          className="container h-[19rem] lg:h-[23rem] xl:h-[25rem] 1.5xl:h-[29rem] 2xl:h-[29rem] 2.5xl:h-[35rem] 3xl:h-[38rem] 4xl:h-[45rem]  mt-24 sm:mt-28 4xl:mt-36  mb-16 sm:mb-20 
               lg:mb-20 4xl:mb-32 rounded-lg flex items-center gap-8 3xl:gap-16 relative top-banner-top-left-slantk bg-primary"
          // style={{ color: color.tertiary, backgroundColor: color.primary }}
        >
          <div className="absolute top-[-1px] left-[-1px] z-[10] rotate-180">
            <SlantImg className="h-[60px] sm:h-[75px] lg:h-[80px]" />
          </div>
          <div className="pt-12 pl-4 sm:pl-12 lg:pl-16 xl:pl-20 3xl:pl-24 4xl:pl-32 xs-only:pr-4 w-full sm:w-[60%] md:w-[67%] lg:w-[65%]">
            <h2 className="text-[28px] xs:text-3xl sm:text-[31px] md:text-4xl lg:text-[3rem] xl:text-[60px] 2xl:text-[64px] 3xl:text-[78px] 4xl:text-[98px] !leading-[120%] sm:!leading-[100%] mb-3 lg:mb-10 xl:mb-16 uppercase">
              <span className="block">{testPageData?.bannerHeading1Text}</span>
              <span className="block">{testPageData?.bannerHeading2Text}</span>
            </h2>
          </div>
          <div className="hidden sm:block w-[30%] sm:w-[40%] lg:w-[35%] h-full relative">
            <img
              src={testPageData?.softwareTestingBgImage}
              alt="banner image"
              className="absolute w-auto top-0 right-0 h-[19rem] lg:h-full"
            />
          </div>
        </section>
        {/* paragraph starts here  */}
        <section className="mb-20 sm:mb-28 lg:mb-40">
          <div className="container text-white lg:pl-12 3xl:pl-16">
            <section className="w-full sm:w-[98%] lg:w-[75%] mb-16 sm:mb-20 lg:mb-20 4xl:mb-32 ">
              <h2 className="uppercase text-[30px] lg:text-[38.5px] xl:text-[48px] 2xl:text-[53px] 3xl:text-[68px] 4xl:text-[82px] leading-[1] text-white w-auto mb-4 sm:mb-6">
                {testPageData?.softwareQABuildForRealWorldDemandsText}{" "}
              </h2>
              {testPageData?.softwareQABuildForRealWorldDemandsParagraph1 && (
                <p className="mb-4 sm:mb-6 font-18-18-18 leading-[120%] sm:font-medium">
                  {FormatTextFromGeneralConstants(
                    testPageData?.softwareQABuildForRealWorldDemandsParagraph1
                  )}
                </p>
              )}
              {testPageData?.softwareQABuildForRealWorldDemandsParagraph2 && (
                <p className="mb-4 sm:mb-6 font-18-18-18 leading-[120%] sm:font-medium">
                  {FormatTextFromGeneralConstants(
                    testPageData?.softwareQABuildForRealWorldDemandsParagraph2
                  )}
                </p>
              )}

              <div className="w-full sm:w-fit cursor-pointer mt-10 sm:mt-0">
                <ButtonSlant
                  buttonClass="text-[18px] 2xl:text-[21.6px] 3xl:text-[27px] 4xl:text-[32.4px] px-5 py-2.5 4xl:py-3 4xl:px-4 border-[3px] font-dela rounded-md w-full sm:w-fit border-primary text-primary"
                  buttonText={testPageData?.letsTalkText}
                  divClass="w-fit"
                  textColorHover="#1a1a1a"
                  bgColorHover="#ff8200"
                  onClick={(e) => {
                    navigate(navigateTo(clientUrls.contact));
                  }}
                  slantClass="bottom-right-slant"
                />
              </div>
            </section>
          </div>
        </section>
        {/*-------------- Paragraph ends here -------------*/}
        {/* ------------Benefits starts here */}
        <div className="relative">
          <div className="absolute right-[-3rem] sm:right-0 top-[-3.5rem] sm:top-[-12rem] xl:top-[-10rem] z-[-1] sm-only:right-[-16rem] md-only:right-[-13rem]">
            <img
              src={testPageData?.serviceTypeBgImage}
              alt="ptw-side"
              className="w-[90%] sm-only:w-[65%] md-only:w-[60%] lg:w-[45%] float-right"
            />
          </div>
          {benifits?.map((service, index) => {
            return (
              <SwiperSlideCommon
                service={service}
                key={index}
                color={{
                  primary: serviceColors[0]?.colorCode,
                  tertiary: serviceColors[0]?.tertiaryColor,
                }}
                showHeading={true}
              />
            );
          })}
        </div>
        {/* ------------Benefits ends here */}
        <section className="mb-20 sm:mb-28 lg:mb-40">
          <div className="container text-white ">
            <h2 className="uppercase font-36-48-72 leading-[1] text-white w-auto mb-4 sm:mb-6 lg:mb-16">
              {testPageData?.ourSolutionsText}{" "}
            </h2>
            {testPageData?.ourSolutionsParagraph && (
              <p className="mb-4 sm:mb-6 font-18-18-18 leading-[120%] sm:font-medium format-text">
                <FormatText text={testPageData?.ourSolutionsParagraph} />
              </p>
            )}
            {/* {testPageData?.softwareQABuildForRealWorldDemandsParagraph2 && (
                <p className="mb-4 sm:mb-6 font-18-18-18 leading-[120%] sm:font-medium">
                  {FormatTextFromGeneralConstants(
                    testPageData?.softwareQABuildForRealWorldDemandsParagraph2
                  )}
                </p>
              )} */}
          </div>
        </section>
        {/*-------------- We've got you covered -------------- */}
        <h2 className="container uppercase font-36-48-72 leading-[1] text-white w-auto mb-4 sm:mb-6 lg:mb-16">
          {testPageData?.weHaveGotYouCoveredText}{" "}
        </h2>
        <AAACoDev
          gameServices={subServices}
          color={{
            primary: serviceColors?.[0]?.colorCode,
            tertiary: serviceColors?.[0]?.tertiaryColor,
          }}
          isQualityAssurance={true}
        />
        <div className="container  cursor-pointer mt-16 sm:mt-24">
          <ButtonSlant
            buttonClass="text-[18px] 2xl:text-[21.6px] 3xl:text-[27px] 4xl:text-[32.4px] px-5 py-2.5 4xl:py-3 4xl:px-4 border-[3px] font-dela rounded-md w-full sm:w-fit border-primary text-primary"
            buttonText={testPageData?.getInTouchText}
            divClass="w-full sm:w-fit"
            textColorHover="#1a1a1a"
            bgColorHover="#ff8200"
            onClick={(e) => {
              navigate(navigateTo(clientUrls.contact));
            }}
            slantClass="bottom-right-slant"
          />
        </div>
        {/*-------------- We've got you covered ends -------------- */}
        {/*------------ certified penetration starts here  */}
        <section className="my-20 sm:my-28 lg:my-40">
          <div className="container text-white lg:pl-12 3xl:pl-16 sm:flex sm:gap-16 md:gap-0">
            <section className="w-full sm:w-1/2 lg:w-[75%] mb-16 sm:mb-20 lg:mb-20 4xl:mb-32 ">
              <h2 className="uppercase text-[30px] lg:text-[38.5px] xl:text-[48px] 2xl:text-[53px] 3xl:text-[68px] 4xl:text-[82px] leading-[1] text-white w-auto mb-4 sm:mb-8">
                {testPageData?.certifiedPenetrationTestingText}{" "}
              </h2>
              {testPageData?.certifiedPenetrationTestingParagraph1 && (
                <p className="mb-4 sm:mb-8 font-18-18-18 leading-[120%] sm:font-medium sm:hidden lg:block">
                  {FormatTextFromGeneralConstants(
                    testPageData?.certifiedPenetrationTestingParagraph1
                  )}
                </p>
              )}

              <div className="w-full sm:w-fit cursor-pointer mt-10 sm:mt-20">
                <ButtonSlant
                  buttonClass="text-[18px] 2xl:text-[21.6px] 3xl:text-[27px] 4xl:text-[32.4px] px-5 py-2.5 4xl:py-3 4xl:px-4 border-[3px] font-dela rounded-md w-full sm:w-fit border-primary text-primary"
                  buttonText={testPageData?.learnMoreText}
                  divClass=" w-full sm:w-fit"
                  textColorHover="#1a1a1a"
                  bgColorHover="#ff8200"
                  onClick={(e) => {
                    navigate(navigateTo(clientUrls.pentesting));
                  }}
                  slantClass="bottom-right-slant"
                />
              </div>
            </section>
            <div className="hidden sm:block lg:hidden w-1/2">
              {testPageData?.certifiedPenetrationTestingParagraph1 && (
                <p className="mb-4 sm:mb-6 font-18-18-18 leading-[120%] sm:font-medium">
                  {FormatTextFromGeneralConstants(
                    testPageData?.certifiedPenetrationTestingParagraph1
                  )}
                </p>
              )}
              {testPageData?.certifiedPenetrationTestingParagraph2 && (
                <p className="mb-4 sm:mb-6 font-18-18-18 leading-[120%] sm:font-medium">
                  {FormatTextFromGeneralConstants(
                    testPageData?.certifiedPenetrationTestingParagraph2
                  )}
                </p>
              )}
            </div>
          </div>
        </section>
        {/* Industry sectors start */}
        <section className="container mt-12 sm:mt-28 lg:mt-44  lg:flex gap-16 2xl:gap-12 4xl:gap-24 justify-between">
          <h2 className="uppercase text-[32px] sm:text-[36px] lg:text-[38.5px] xl:text-[48px] 2xl:text-[53px] 3xl:text-[68px] 4xl:text-[82px] text-white leading-[1] sm:w-[75%] lg:w-2/5 2xl:w-[45%]">
            {testPageData?.industrySectorsText}
          </h2>
          <div className="sm:mx-auto grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 gap-8 lg:gap-6 4xl:gap-8 mt-6 sm:mt-12 lg:mt-0 w-[95%] 1.5xs:w-[90%] sm:w-[95%] lg:w-3/5 2xl:w-[55%]">
            {industry?.map((serviceLogo, i) => {
              return (
                <div
                  key={serviceLogo?.meta_value}
                  className="flex items-center flex-col"
                >
                  <div
                    key={serviceLogo?.meta_value}
                    className="w-full h-auto  border-[0.16px] border-[#ffffff20] flex justify-center items-center py-8 1.5xs:py-12 sm:py-8 1.5md:py-10 lg:py-12 3xl:py-14 3.5xl:py-20 4xl:py-24"
                  >
                    <img
                      src={serviceLogo?.industryImage}
                      alt="client logo"
                      className="h-[4rem]"
                    />
                  </div>
                  <p className="font-16-16-16 text-white mt-4">
                    {serviceLogo?.industryTitleText}
                  </p>
                </div>
              );
            })}
          </div>
        </section>
        {/* Industry sectors end */}
        <div className="relative pt-16 sm:pt-40 lg:pt-56">
          <div className="hidden lg:block absolute left-[-27rem] z-[-1] top-[2rem]">
            <img
              src={testPageData?.labsBgImage}
              alt="side-ptw"
              className="w-[60%]"
            />
          </div>

          <NewsEvents
            header1={
              testPageData?.bannerHeading1Text +
              " " +
              testPageData?.bannerHeading2Text
            }
            header2={testPageData?.fromTheLabText}
            headerButtonText={testPageData?.visitTheLabText}
            cardsData={labs}
            colors={{
              color: serviceColors?.[0]?.secondaroyColor,
              tertiaryColor: serviceColors?.[0]?.tertiaryColor,
            }}
            url={clientUrls.labs}
            toLabs={true}
          />
        </div>
        <section className="mt-12 lg:mt-44 relative">
          <OurServices
            servicesData={services}
            header1={testPageData?.exploreText}
            header2={testPageData?.moreText}
            colors={{ color: serviceColors?.[0]?.colorCode }}
            lang={lang}
          />
        </section>
      </section>
      <Footer />
    </>
  );
};

export default SoftwareTesting;
